import { create } from 'zustand'

export type ConnectionStatus = {
  status: 'connected' | 'disconnected' | 'reconnecting'
  reconnectIn?: number // milliseconds until reconnect
  timestamp?: number // timestamp of status change
}

export type Winner = 'player' | 'opponent' | 'tie'

type AppState = {
  updateState: <T>(key: string, value: T) => void
  loaded?: boolean
  userLoaded?: boolean
  delta?: number
  errors?: { [key: string]: string }
  loginSuccess?: boolean
  params?: { [key: string]: string }[],
  isCallingApi?: boolean,
  ownedItems?: number[],
  modalMissionStatus?: boolean,
  currentPhase?: number,
  getParam: (key: string) => string | undefined
  getError: (error: unknown) => string
}

export const useStore = create<AppState>((set, get) => ({
  loaded: false,
  userLoaded: false,
  delta: 0,
  errors: {},
  params: [],
  loginSuccess: false,
  isCallingApi: false,
  ownedItems: [],
  modalMissionStatus: false,
  currentPhase: 1,
  getParam: (key: string) => {
    const params = get().params as unknown as Record<string, string> | undefined
    return params?.[key]
  },
  getError: (error: unknown) => {
    const errors = get().errors
    const err = error as { code?: string; message?: string }
    const key = (err?.message || err?.code) as string
    return errors?.[key] || `Hệ thống chưa thể thực hiện thao tác của bạn: ${key}`
  },
  updateState: <T>(key: string, value: T) => set(() => ({
    [key]: value
  }))
} as unknown as AppState))